import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './StepList.css';

// Numbered 1-2-3(-4) step list. Horizontal on desktop, stacked on mobile.
// `steps` = [{ title, text, icon? }]. `accent` = 'red' (default) | 'green'.
// Optional `heading` renders an <h2> above the row.
function StepList({ heading, steps = [], accent = 'red', columns }) {
  const cols = columns || Math.min(steps.length || 1, 4);
  return (
    <div className={s.block}>
      {heading ? <h2 className={s.heading}>{heading}</h2> : null}
      <ol
        className={`${s.row} ${accent === 'green' ? s.green : ''}`}
        style={{ '--cols': cols }}
      >
        {steps.map((step, i) => (
          <li className={s.step} key={step.title}>
            <div className={s.no}>
              {step.icon ? (
                <svg viewBox="0 0 24 24" aria-hidden="true" className={s.icon}>
                  <path d={step.icon} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              ) : (
                i + 1
              )}
            </div>
            <h3 className={s.title}>{step.title}</h3>
            <p className={s.text}>{step.text}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default withStyles(s)(StepList);
